export default __webpack_public_path__ + "static/media/monkey20.a2518f9a.jpeg";